namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmKonfiguracniSkupina extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmKonfiguracniSkupinaReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmKonfiguracniSkupinaObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmKonfiguracniSkupinaObj());
            this.detailObj.createBase({
                contentName: "detailAdmKonfiguracniSkupina",
                contentCaption: "jres:29932054",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmKonfiguracniSkupina", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmKonfiguracniSkupinaObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmKonfiguracniSkupinaReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["ixs_usr"]
        }

        setSxsDetail(): string {
            return (this.data.ixs_usr) ? this.data.ixs_usr.toString() : "";
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmKonfiguracniSkupinaSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmKonfiguracniSkupina.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmKonfiguracniSkupina", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmKonfiguracniSkupina.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                {
                    favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                        { action: this.cnt.actions.actOpenSeznamProgramovaInstance },
                        { action: this.cnt.actions.actOpenSeznamFunkcnichMist }
                    ]
                },
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSeznamProgramovaInstance: {
                    icon: "fa-link",
                    caption: "jres:29802871",
                    run: (ev, ctx) => {
                        Gordic.Adm.WebControls.AdmKonfiguracniSkupina.openSeznamAdmKonfiguracniSkupinaProgramovaInstance(this.data);
                    }
                },
                actOpenSeznamFunkcnichMist: {
                    icon: "fa-link",
                    caption: "jres:29802922",
                    run: (ev, ctx) => {
                        Gordic.Adm.WebControls.AdmKonfiguracniSkupina.openSeznamAdmFunkcniMistoKonfiguracniSkupina(this.data);
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actOpenSeznamProgramovaInstance?.update({ enabled: editMode == false })
            this.cnt.actions.actOpenSeznamFunkcnichMist?.update({ enabled: editMode == false })
        }

        createForm() {
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ginsico(), { model: "model.ico=value.ico" });
            this.MakeField("ixs_usr");
            this.MakeField("zkratka");
            this.MakeField("nazev");
            this.MakeField("poznamka");

            //this.MakeSelectField("ktg_usr", Gordic.Prefabs.Select.gincusr(), { model: "model.ktg_usr=value.ktg_usr" });
            //this.MakeSelectField("typ_usr", Gordic.Prefabs.Select.ginckus(), { model: "model.typ_usr=value.typ_usr" });

            this.MakeField("dat_od");
            this.MakeField("dat_do");
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
        }
    }
}